import { BLOCKS } from '@contentful/rich-text-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import React, { forwardRef } from 'react';

const RICHTEXT_OPTIONS = {
  preserveWhitespace: true,
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node:any, children:any) => <p className="text-[14px] leading-[18px]">{children}</p>,
  },
};

const TranscriptToPrint = forwardRef(({ innerRef, transcript, transcriptTitle }:any) => {
  const renderTranscriptText = (
    <div>
      <p className="mb-2">
        {transcriptTitle}
      </p>
      {renderRichText(transcript, RICHTEXT_OPTIONS)}
    </div>
  );
  return (
    <div>
      <div id="transcript" className="pl-3 sm:pl-[47px] md:pl-[10px] lg:pl-[47px] pr-[10px] sm:pr-6 md:pr-[10px] lg:pr-6 my-4 sm:my-[27px] md:my-4 lg:my-[27px] max-h-[893px] overflow-auto mr-[11px] sm:mr-[23px] md:mr-[11px] lg:mr-[23px]">
        {renderTranscriptText}
      </div>
      <div className="hidden">
        <div ref={innerRef} className="px-12 py-6">
          {renderTranscriptText}
        </div>
      </div>
    </div>
  );
});

export default TranscriptToPrint;
